import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import propTypes from 'prop-types'
import orderBy from 'lodash/orderBy'
import get from 'lodash/get'
import moment from 'moment'

import EPL from './EPL'
import Checkbox from '@components/Checkbox'
import EmptyIcon from '@components/Icon/Empty'
import Spinner from '@components/spinner'
import LinearProgress from '@material-ui/core/LinearProgress'
import { IconMultiUserMedium } from '@atheneum/faster-scheduling/dist/components/IconMultiUser'
import { capi } from '@atheneum/api'

class EPLs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      capiSegmentStatuses: {},
      showMultiAction: false,
      multipleExperts: '',
      multipleExpertsResult: []
    }
  }

  componentWillMount() {
    const { eplStore, projectStore, match, history } = this.props
    if (match && match.params.eplId) {
      eplStore.getSingleEPL(projectStore.id, match.params.eplId)
    } else {
      eplStore.getFilterOptions(projectStore.id).then(res => {
        const list = eplStore.getList(projectStore.id)
        list && list.then(() => {
          const selectedEpls = get(history.location.state, 'selectedEpls')
          if (selectedEpls) {
            eplStore.eplModels = eplStore.eplModels.map(epl => {
              if (selectedEpls.includes(epl.id)) {
                epl.batchChecked = true
              }
              return epl
            })
          }
        })
      })
    }
  }

  batchCheckGroup = (e, eplGroup) => {
    const allEplsChecked = this.allEplsChecked(eplGroup)
    if (allEplsChecked && e === false) {
      eplGroup.epls.forEach(epl => {
        epl.batchCheck(false)
      })
    } else if (e === true) {
      eplGroup.epls.forEach(epl => {
        epl.batchCheck(true)
      })
    }
  }

  allEplsChecked = eplGroup => {
    const hasUnchecked = eplGroup.epls.find(epl => epl.batchChecked === false)
    const hasChecked = eplGroup.epls.find(epl => epl.batchChecked === true)
    return !hasUnchecked && hasChecked
  }

  markCompleteAction = async (parrentModel, models) => {
    for (let i = 0; i < models.length; i++) {
      await models[i]
        .handleInterviewed(moment().format('YYYY-MM-DD'))
        .then(() => {
          models[i].handleUpdateOnChange({
            updateDetails: false,
            updateFilter: true,
            fields: {
              eplStatusId: 10
            }
          })
        })
    }
    this.props.eplStore.growlStore.showError(
      "honorarium and Fee bundle missing <br/> Please create them manually on EPL's"
    )
  }

  reScheduleAction = (parrentModel, models) => {
    this.props.modalStore.show({
      type: 'SCHEDULE_CALENDAR_MODAL',
      props: {
        eplModel: parrentModel,
        epl: parrentModel.epl,
        project: this.props.projectStore.project,
        multipleExperts: models,
        multiAction: true,
        // projectStore: this.props.projectStore
      }
    })
  }

  addExpertAction = (parrentModel) => {
    this.props.modalStore.show({
      type: 'SCHEDULE_CALENDAR_MODAL',
      props: {
        eplModel: parrentModel,
        epl: parrentModel.epl,
        project: this.props.projectStore.project,
        showAddExpert: true,
        // projectStore: this.props.projectStore
      }
    })
  }

  renderMultiple = (eplGroup, multiple) => {
    const models = eplGroup.epls.filter(model =>
      multiple.includes(model.epl.expert.fullName.replace(/,/g, ''))
    )

    return (
      <div className="multiExpertContainer">
        <div className="multiExpertTitle">
          <div className="multiExpertIconContainer">
            <IconMultiUserMedium color={'#30009c'} />
            <h3>Multi Expert Meeting</h3>
          </div>

          <button
            onClick={() =>
              this.setState({ showMultiAction: !this.state.showMultiAction })
            }
            onBlur={() =>
              setTimeout(() => this.setState({ showMultiAction: false }), 350)
            }>
            <div></div>
            <div style={{ margin: '0 4px' }}></div>
            <div></div>
          </button>

          {this.state.showMultiAction && (
            <div className="multiExpertActionContainer">
              <p onClick={() => this.markCompleteAction(models[0], models)}>
                Mark as Complete
              </p>

              <p onClick={() => this.reScheduleAction(models[0], models)}>
                Re-Schedule
              </p>

              <p onClick={() => this.addExpertAction(models[0])}>Add Expert</p>
            </div>
          )}
        </div>

        {this.renderEpls(
          eplGroup.epls.filter(model => {
            return multiple.includes(model.epl.expert.fullName.replace(/,/g, ''))
          })
        )}
      </div>
    )
  }

  async getCapiWorkstreamStatuses() {
    if (this.props.eplStore.groupedEplModels && this.props.eplStore.groupedEplModels.length) {
      await Promise.all(
        this.props.eplStore.groupedEplModels.map(async group => {
          const capiWorkstream = await capi.getWorkstream(group.segment.id)
          this.setState({
            capiSegmentStatuses: {
              ...this.state.capiSegmentStatuses,
              [group.segment.name]: capiWorkstream.live
            }
          })
        })
      )
    }
  }

  async componentDidMount() {
    await this.getCapiWorkstreamStatuses()
  }

  formatCapiWorkstreamStatus = (live) => {
    if (typeof (live) === 'undefined') return ''
    if (live) return '- live'
    return '- not live'
  }

  renderGroups = () => {
    const groups = this.props.eplStore.groupedEplModels
    const { groupBy } = this.props.eplStore
    const { segments } = this.props.segmentStore
    if (!groups || groups.length < 1) return
    return groups.map(eplGroup => {
      const checkedGroup = !!this.allEplsChecked(eplGroup)

      let segment = ''

      if (groupBy === 'segments') {
        segment = toJS(segments).find(
          segment => segment.id === eplGroup.segment.id
        )
        if (!segment) return null
      }

      const segmentNames = eplGroup.epls.map(epl => epl.epl.expert.fullName.replace(/,/g, ''))
      const haveMulti = this.state.multipleExpertsResult.some(x =>
        x.every(name => segmentNames.includes(name))
      )

      const multiExperts = this.state.multipleExpertsResult.filter(arr =>
        arr.every(name => segmentNames.includes(name))
      )

      const capiWorkstreamStatus = this.formatCapiWorkstreamStatus(this.state.capiSegmentStatuses[eplGroup.groupBy])
      return (
        <div key={eplGroup.key}>
          <div className="group-label">
            <Checkbox
              value={checkedGroup}
              onChange={e => this.batchCheckGroup(e, eplGroup)}
            />

            {groupBy === 'segments' ? (
              <h2>
                {eplGroup.groupBy || 'Unnamed Segment'} ({eplGroup.epls.length}{' '}
                / {segment.numberOfExpert}) {capiWorkstreamStatus}
              </h2>
            ) : (
              <h2>
                {eplGroup.groupBy} ({eplGroup.epls.length}) {capiWorkstreamStatus}
              </h2>
            )}

            {groupBy === 'segments' ? (
              <span
                onClick={() => this.editSegment(eplGroup.key)}
                className="group-label__more">
                View / edit segment details
              </span>
            ) : null}
          </div>

          {haveMulti && (
            <>
              {/* multis */}
              {this.state.multipleExpertsResult
                .filter(arr => arr.every(name => segmentNames.includes(name)))
                .map(multiple => {
                  return this.renderMultiple(eplGroup, multiple)
                })}

              {/* The rest */}
              {this.renderEpls(
                eplGroup.epls.filter(
                  model =>
                    !multiExperts.some(multi =>
                      multi.includes(model.epl.expert.fullName.replace(/,/g, ''))
                    )
                )
              )}
            </>
          )}
          {!haveMulti && <>{this.renderEpls(eplGroup.epls)}</>}
        </div>
      )
    })
  }

  editSegment = id => {
    this.props.segmentStore.get(id).then(segment => {
      this.props.modalStore.show({
        type: 'SEGMENT_FORM',
        props: {
          segment: segment,
          project: this.props.projectStore.project,
          segmentStore: this.props.segmentStore
        }
      })
    })
  }

  orderEpls = epls => {
    const { NOT_AVAILABLE, NOT_APPROVED, REJECTED } =
      this.props.staticData.CONST.EPL_STATUSES

    const rejectedEPLS = []
    const notApprovedEPLS = []
    const notAvailableEPLS = []
    const otherEPLS = []

    epls.forEach(eplModel => {
      if (eplModel.epl.eplStatusId === REJECTED) {
        rejectedEPLS.push(eplModel)
        return
      }
      if (eplModel.epl.eplStatusId === NOT_APPROVED) {
        notApprovedEPLS.push(eplModel)
        return
      }
      if (eplModel.epl.eplStatusId === NOT_AVAILABLE) {
        notAvailableEPLS.push(eplModel)
        return
      }

      otherEPLS.push(eplModel)
    })

    const otherOrderedEPLS = orderBy(otherEPLS, ['epl.eplStatusId'], ['desc'])

    return [
      ...otherOrderedEPLS,
      ...notAvailableEPLS,
      ...notApprovedEPLS,
      ...rejectedEPLS
    ]
  }

  renderEpls = epls => {
    const { eplStore } = this.props

    if (!epls || epls.length < 1) {
      if (eplStore.isExpertQuickSearchActive) {
        return this.renderEmptyGroup('No experts match your search', '')
      }

      return this.renderEmptyGroup(
        'There are no EPLs in this segment',
        'Try selecting another one.'
      )
    }

    return this.orderEpls(epls).map(epl => {
      return this.renderEpl(epl)
    })
  }

  renderSingleEpl = () => {
    const { eplSingle } = this.props.eplStore
    if (!eplSingle) {
      return this.renderEmptyGroup(
        'Could not find epl!',
        'Link may be broken or outdated.'
      )
    }

    return this.renderEpl(eplSingle)
  }

  renderEpl = epl => {
    return (
      <EPL
        key={epl.epl.id}
        eplModel={epl}
        epl={epl.epl}
        match={this.props.match}
        eplStore={this.props.eplStore}
        staticData={this.props.staticData}
        project={this.props.project}
      />
    )
  }

  renderEmptyGroup = (title, text) => {
    return (
      <div className="ep-wrapper__empty-group">
        <EmptyIcon />
        <div className="ep-wrapper__empty-group__center">
          <h3>{title}</h3>
          <span>{text}</span>
        </div>
      </div>
    )
  }

  _extractExperts = res =>
    res
      .flat()
      .map(x => x.expertNames)
      .map(x => x.split(', '))
      .filter(x => x.length > 1 && res !== undefined)

  render() {
    // Review: this makes request to /zoom-meetings every render, should be moved to when component loads / MEM is created/updated
    this.props.eplStore
      .getMultipleExperts(this.props.eplStore.eplModels)
      .then(res => {
        if (!res) {
          return
        }
        const multipleExperts = this._extractExperts(res).join('target')
        if (this.state.multipleExperts === multipleExperts) {
          return
        }
        return this.setState({
          multipleExpertsResult: this._extractExperts(res),
          multipleExperts,
        })
      })

    const { eplStore, match } = this.props

    if (eplStore.loading) return <Spinner />

    const isSingleEplDisplay = match && match.params.eplId

    return (
      <div className="ep-wrapper__table">
        {eplStore.partialLoad && (
          <div>
            Loading additional items
            <LinearProgress />
          </div>
        )}
        {isSingleEplDisplay ? this.renderSingleEpl() : this.renderGroups()}
      </div>
    )
  }
}

EPLs.propTypes = {
  staticData: propTypes.object,
  eplStore: propTypes.object,
  projectStore: propTypes.object,
  project: propTypes.object,
  segmentStore: propTypes.object,
  modalStore: propTypes.object,
  match: propTypes.object,
  history: propTypes.object
}

export default withRouter(
  inject(
    'eplStore',
    'projectStore',
    'staticData',
    'segmentStore',
    'modalStore'
  )(observer(EPLs))
)
